<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
-->

<template>
  <v-dialog
    class="intent-of-use-dialog"
    :value="showDialog"
    persistent
    max-width="50%"
  >
    <div class="intent-of-use-card">
      <v-layout column>
        <h1 class="pb-4 pt-4 pl-4 font-bold">Intent of Use Acknowledgment</h1>
        <div class="text-xs-center">
          <img
            src="@/assets/intent_of_use_acknowledgement.png"
            style="text-align: center"
          />
        </div>
        <div class="px-4">
          <p>
            By using ExclusionCheck, you are granted expedited access to primary
            source exclusion data. In conducting searches and viewing results,
            you acknowledge:
          </p>
          <ul style="list-style: disc !important;" class="pb-4 pl-5">
            <li>
              Employment decisions
              <strong>will not be made based on potential matches</strong>
            </li>
            <li>
              You or your organization will take the necessary steps to confirm
              any potential matches are applicable to your employees, vendors,
              or contractors <strong>before making any final decisions</strong>
            </li>
          </ul>
        </div>
        <div class="text-xs-right pb-3 pr-3">
          <v-btn
            @click.stop="
              $emit('close-intent-of-use', closeable)
              $emit('set-toaster', errorMessage)
            "
            >I Decline</v-btn
          >
          <v-btn
            class="primary"
            @click.stop="
              $emit('action')
              $emit('set-toaster', null)
            "
            >I Acknowledge</v-btn
          >
        </div>
      </v-layout>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "IntentOfUseDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    errorMessage:
      "You must acknowledge intent of use in order to use Exclusioncheck"
  })
}
</script>

<style scoped>
.intent-of-use-card {
  width: 100%;
  height: auto;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/IntentOfUseDialog.vue